export const selectMilestoneDefinitionsSchema = ({ milestoneDefinitions }) =>
  milestoneDefinitions?.milestoneDefinitionsSchema;
